import { atom } from "recoil";


const personIdAtom = atom({
    key: 'currentID',
    default: {},
});
  
export default personIdAtom